import React, { Component } from "react";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { withRouter } from "react-router";
import { withTranslation } from "react-i18next";
import CreateMessage from "../messages/CreateMessage";
import RequiredReadingDialog from "./../required-reading/RequiredReadingDialog";

const elementMappings = {
  CreateMessage,
  RequiredReadingDialog,
};
export class MenuLinkDialog extends Component {
  render() {
    let Type = null;
    if (this.state.type) {
      Type = elementMappings[this.state.type];
    }
    return (
      <div>
        <ListItem button onClick={this.onClick}>
          <ListItemIcon>
            <span className="material-icons">{this.props.portlet.icon}</span>
          </ListItemIcon>
          <ListItemText primary={this.props.t(this.props.portlet.title)} />
        </ListItem>
        {Type && <Type onClose={this.onClose}></Type>}
      </div>
    );
  }
  constructor(props) {
    super(props);
    this.state = {
      type: null,
    };
  }
  onClose = () => {
    this.setState({ type: null });
  };
  onClick = () => {
    let params = JSON.parse(this.props.portlet.parameters);
    this.setState({ type: params.type });
  };
}

export default withRouter(withTranslation()(MenuLinkDialog));
